import { create } from 'zustand/react';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { safeSessionStorage } from '@pkgs/components/utils/storageUtils';

import { isProductionClient } from '../../../consts/environment';

export const PROMPT_STORE_KEY = 'prompt-store';

type PromptStoreStore = {
  promptValue: string;
  setPromptValue: (value: string) => void;
};

export const usePromptStore = create<PromptStoreStore>()(
  persist(
    devtools(
      (set) => ({
        promptValue: '',
        setPromptValue: (value) => set({ promptValue: value }),
      }),
      {
        name: 'search-modules',
        store: PROMPT_STORE_KEY,
        enabled: !isProductionClient,
      },
    ),
    {
      name: PROMPT_STORE_KEY,
      storage: createJSONStorage(() => safeSessionStorage),
    },
  ),
);
